import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconSolverMechanicsSizeM from './IconSolverMechanics_size_m';

const props: CreateIconArguments = {
  l: IconSolverMechanicsSizeM,
  m: IconSolverMechanicsSizeM,
  s: IconSolverMechanicsSizeM,
  xs: IconSolverMechanicsSizeM,
  name: 'IconSolverMechanics',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
